




































import Vue from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { IProductImage } from '@/common/interfaces/products.interface';
import { ISplideOptions, ISplideVue } from '@/common/interfaces/external.interface';
import ImageWithErrorMessage from '@/components/newsingleproductpage/subcomponents/imagewitherrormessage/ImageWithErrorMessage.vue';
import TIcons from '@/types/TIcons';
import { IIcons } from '@/common/interfaces/index.interface';

interface IImageGallery {
  icons: IIcons;
  splideOptions: ISplideOptions;
}

export default Vue.extend({
  components: { ImageWithErrorMessage, Splide, SplideSlide },
  data(): IImageGallery & { $refs?: { splideRef: ISplideVue } } {
    return {
      icons: TIcons,
      splideOptions: {
        arrowPath: `M14.4697 9.96967C14.7626 9.67678 15.2374 9.67678 15.5303 9.96967L25.5303 19.9697C25.8232 20.2626 25.8232 20.7374 25.5303 21.0303L15.5303 31.0303C15.2374 31.3232 14.7626 31.3232 14.4697 31.0303C14.1768 30.7374 14.1768 30.2626 14.4697 29.9697L23.9393 20.5L14.4697 11.0303C14.1768 10.7374 14.1768 10.2626 14.4697 9.96967Z`,
        arrows: this.images.length > 1,
        pagination: false,
        type: this.images.length > 1 ? `loop` : `slide`,
      },
    };
  },
  props: {
    currentSlideIndex: {
      required: true,
      type: Number,
    },
    images: {
      required: true,
      type: Array as () => IProductImage[],
    },
    isVisible: {
      required: true,
      type: Boolean,
    },
  },
  watch: {
    isVisible(): void {
      if(!this.isVisible) {
        return;
      }
      this.$refs.splideRef.splide.destroy();
      this.$refs.splideRef.splide.options.start = this.currentSlideIndex;
      this.$refs.splideRef.splide.mount();
    },
  },
});
